<template>
  <v-row>
    <v-col>
      <p class="text-">{{ title }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: { type: String },
  },
};
</script>
